module.exports = __webpack_public_path__ + "img/oxford-logo3.fe1facdb.png";